import * as React from 'react';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from "@material-ui/icons/Search";
import cn from 'classnames';
import './BookFind.css';
import Collapse from '@material-ui/core/Collapse';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import CloseIcon from '@material-ui/icons/Close';

interface Props {
	onInputChanged?: (value: string) => void;
	onClose?: () => void;
	className?: string;
	disabled?: boolean;
}

const BookFind: React.FunctionComponent<Props> = props => {
	const [inputVisible, setInputVisible] = React.useState(false);
	const inputRef = React.useRef<HTMLInputElement>(null);

	const onClose = () => {
		props.onClose();
		inputRef.current.value = "";
		setInputVisible(false);
	}

	const onInputChange = (e: any) => {
		props.onInputChanged(e.target.value);
	}

	return <div className={cn('bookFind', props.className)}>
		{props.children}

		<div>
			{!props.disabled && <IconButton onClick={() => setInputVisible(true)}>
				<SearchIcon htmlColor="#ffffff" />
			</IconButton>}
		</div>

		<Collapse className="bookFind__input" in={inputVisible}>
			<TextField
				onChange={onInputChange}
				autoFocus={true}
				placeholder="Поиск по названию"
				InputProps={{
				inputRef: inputRef,
				endAdornment: <InputAdornment position="end">
					<IconButton>
						<CloseIcon onClick={onClose}/>
					</IconButton>
				</InputAdornment>
			}}/>
		</Collapse>
	</div>;
};

export default BookFind;
